// Menu reference: page id <-> slug <-> page name (from the design's menuData).
// Navigation routes by slug, never by page id. `built: false` points the link at the
// 404 fallback until the real page component exists.
export const APP_NAME = 'ChargeOS';
export const DEFAULT_SLUG = 'station-locator-availability';

export const MENU_ITEMS = [
  {
    pageId: 73871,
    moduleId: 22706,
    slug: 'user-role-management',
    name: "Users & Permissions",
    icon: 'fas fa-user-shield',
    showInBottomBar: false,
    shortLabel: "Admin",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73892,
    moduleId: 22711,
    slug: 'live-charging-telemetry',
    name: "Active Charging",
    icon: 'fas fa-bolt',
    showInBottomBar: true,
    shortLabel: "Charging",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73893,
    moduleId: 22711,
    slug: 'station-locator-availability',
    name: "Find Stations",
    icon: 'fas fa-map-marker-alt',
    showInBottomBar: true,
    shortLabel: "Stations",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73894,
    moduleId: 22711,
    slug: 'connector-reservation',
    name: "Reservations",
    icon: 'fas fa-clock',
    showInBottomBar: true,
    shortLabel: "Reserve",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73898,
    moduleId: 22709,
    slug: 'noc-fleet-monitoring-alarms',
    name: "Fleet NOC & Alarms",
    icon: 'fas fa-shield-alt',
    showInBottomBar: false,
    shortLabel: "Fleet",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73903,
    moduleId: 22707,
    slug: 'wallet-top-up-payment',
    name: "Wallet & Payments",
    icon: 'fas fa-wallet',
    showInBottomBar: true,
    shortLabel: "Wallet",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73905,
    moduleId: 22706,
    slug: 'driver-directory-mini-crm',
    name: "Driver Directory",
    icon: 'fas fa-id-card-alt',
    showInBottomBar: false,
    shortLabel: "Drivers",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
  {
    pageId: 73906,
    moduleId: 22707,
    slug: 'executive-management-dashboard',
    name: "Executive Dashboard",
    icon: 'fas fa-chart-line',
    showInBottomBar: false,
    shortLabel: "Executive",
    built: true, // flip to true when ui-components-from-reference builds the page; false routes to /404
  },
];

MENU_ITEMS.push({
  pageId: 73899,
  moduleId: 22705,
  slug: 'user-profile-vehicle-settings',
  name: 'My Profile & Vehicles',
  icon: 'fas fa-user-gear',
  showInBottomBar: false,
  shortLabel: 'Profile',
  built: true,
});

MENU_ITEMS.push({
  pageId: 'a5bc5293-059e-4cc0-9122-7c742926d383',
  moduleId: 'd0740232-6d8d-4cf9-9666-043fb6b19dd5',
  slug: 'charger-models-compatibility',
  name: 'Charger Models & Compatibility',
  icon: 'fas fa-microchip',
  showInBottomBar: false,
  shortLabel: 'Models',
  built: true,
});

MENU_ITEMS.push({
  pageId: 'c8487f6c-55e7-4b72-9d83-6ad74e78bad5',
  moduleId: '074047fd-6fae-426a-a6c5-7debda516836',
  slug: 'tariff-configuration',
  name: 'Tariff Configuration',
  icon: 'fas fa-tags',
  showInBottomBar: false,
  shortLabel: 'Tariffs',
  built: true,
});

MENU_ITEMS.push({
  pageId: 'c8229ce9-2894-438f-8f90-f43f8fa76bdf',
  moduleId: 'd0740232-6d8d-4cf9-9666-043fb6b19dd5',
  slug: 'charger-remote-controls',
  name: 'Remote Controls',
  icon: 'fas fa-terminal',
  showInBottomBar: false,
  shortLabel: 'Remote',
  built: true,
});

MENU_ITEMS.push({
  pageId: '7ebac161-add2-4d13-845d-7366ac5141e4',
  moduleId: '5e602c82-5de0-425b-955a-32ee74123a92',
  slug: 'maintenance-tickets-diagnostics',
  name: 'Maintenance Tickets',
  icon: 'fas fa-tools',
  showInBottomBar: false,
  shortLabel: 'Tickets',
  built: true,
});

MENU_ITEMS.push({
  pageId: 'f02d74e6-7c6b-4edc-89ad-9ca26880de3b',
  moduleId: '5e602c82-5de0-425b-955a-32ee74123a92',
  slug: 'customer-dispute-adjustment-console',
  name: 'Customer Disputes',
  icon: 'fas fa-headset',
  showInBottomBar: false,
  shortLabel: 'Disputes',
  built: true,
});

MENU_ITEMS.push({
  pageId: 73902, // finance role landing page id (see login/loginRoles.js)
  moduleId: '074047fd-6fae-426a-a6c5-7debda516836',
  slug: 'financial-reconciliation-ledger',
  name: 'Financial Ledger',
  icon: 'fas fa-balance-scale',
  showInBottomBar: false,
  shortLabel: 'Ledger',
  built: true,
});

MENU_ITEMS.push({
  pageId: 'charger-onboarding',
  moduleId: 'd0740232-6d8d-4cf9-9666-043fb6b19dd5',
  slug: 'charger-onboarding',
  name: 'Charger Onboarding',
  icon: 'fas fa-plug-circle-plus',
  showInBottomBar: false,
  shortLabel: 'Onboard',
  built: true,
});

export const menuByPageId = Object.fromEntries(MENU_ITEMS.map((m) => [m.pageId, m]));

// ---- Role-based access (RBAC) -------------------------------------------------
// Single source of truth for which roles may open a page. App.jsx guards its routes
// with these same lists and AppShell builds the navigation from them, so a link is
// only ever shown to a role that can actually open it.
export const PUBLIC = 'public'; // no sign-in required
export const ANY_SIGNED_IN = 'any'; // every authenticated role

export const ACCESS = {
  admin: ['admin'],
  driver: ['driver', 'user', 'admin'],
  noc: ['noc', 'admin'],
  customerCare: ['admin', 'customer_care'],
  finance: ['finance', 'admin'],
  maintenance: ['field_technician', 'noc', 'admin'],
};

const ACCESS_BY_SLUG = {
  'station-locator-availability': PUBLIC,
  'user-profile-vehicle-settings': ANY_SIGNED_IN,
  'user-role-management': ACCESS.admin,
  'charger-models-compatibility': ACCESS.admin,
  'tariff-configuration': ACCESS.admin,
  'wallet-top-up-payment': ACCESS.driver,
  'connector-reservation': ACCESS.driver,
  'live-charging-telemetry': ACCESS.driver,
  'noc-fleet-monitoring-alarms': ACCESS.noc,
  'charger-remote-controls': ACCESS.noc,
  'charger-onboarding': ACCESS.noc,
  'driver-directory-mini-crm': ACCESS.customerCare,
  'customer-dispute-adjustment-console': ACCESS.customerCare,
  'financial-reconciliation-ledger': ACCESS.finance,
  'executive-management-dashboard': ACCESS.finance,
  'maintenance-tickets-diagnostics': ACCESS.maintenance,
};

/** True when a visitor with `role` (undefined = signed out) may open the menu item. Unmapped pages are hidden. */
export function canAccess(item, role) {
  const access = ACCESS_BY_SLUG[item.slug];
  if (!access) return false;
  if (access === PUBLIC) return true;
  if (!role) return false;
  return access === ANY_SIGNED_IN || access.includes(role);
}

/** Menu items a role may open, in menu order. */
export const menuForRole = (role) => MENU_ITEMS.filter((m) => canAccess(m, role));

export const routeFor = (item) => (item.built ? `/${item.slug}` : '/404');
